import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Slider, Tooltip } from 'antd';
import styles from "./scss/imagezoom.module.scss";
import ChatLike from "../chatWidgets/chatLike";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import _ from "lodash";
import store from "../../../context/store/store";
type imagePreviewProps = {
  data?: any;
  url?: any;
}
type imagePreviewState = {
  height: any,
  width: any,
  steps: any,
  imgWidth: any,
  imgHeight: any,
  isZoomCount: any,
  isZoom: boolean;

}
export default function ImageZoom({ data, url }: imagePreviewProps) {
  let messageBody = data?.message?.body;
  let filePath = messageBody?.filePath;
  const resetTransformRef = useRef<() => void | null>(null);
  const {imgIndex}=store.getState().chatReducer;
  const [zoomdetails, setzoomdetails] = useState<imagePreviewState>({
    height: "",
    width: "",
    steps: 1,
    imgWidth: '',
    imgHeight: '',
    isZoomCount: 1,
    isZoom: false

  });
  useEffect(() => {
    let GFG: any = document.querySelector(".imageZoom");
    let GFGAA: any = document.querySelector("#imgzoom");
    setzoomdetails({
      ...zoomdetails, imgWidth: GFG.clientWidth, imgHeight: GFG.offsetHeight, height: GFGAA.offsetHeight === 0 ? 320 : GFGAA.offsetHeight,
      width: "", steps: 1
    });
  }, []);
  useLayoutEffect(() => {
    if (resetTransformRef?.current) {
      resetTransformRef.current();
      setzoomdetails({
        ...zoomdetails, steps: 1
      });
    }
  }, [imgIndex]);

  // const hadleMouseWheel = (evt: any) => {
  //   if (evt.deltaY > 0) {
  //     let newWidth = zoomdetails.width - 1;
  //     let newHeight = zoomdetails.height - 1;
  //     if (newWidth < zoomdetails.imgWidth && newHeight < zoomdetails.imgHeight) {
  //       setzoomdetails({ ...zoomdetails, height: zoomdetails.imgHeight, width: zoomdetails.imgWidth, steps: zoomdetails.steps - 1 });

  //     }
  //     else {
  //       setzoomdetails({ ...zoomdetails, height: newHeight, width: newWidth, steps: zoomdetails.steps - 1 });

  //     }
  //   } else if (evt.deltaY < 0) {
  //     let newWidth = zoomdetails.width + 1;
  //     let newHeight = zoomdetails.height + 1;
  //     if (newWidth > zoomdetails.imgWidth + 100 && newHeight > zoomdetails.imgHeight + 100) {
  //       setzoomdetails({ ...zoomdetails, steps: zoomdetails.steps + 1 });
  //     }
  //     else {
  //       setzoomdetails({ ...zoomdetails, height: newHeight, width: newWidth, steps: zoomdetails.steps + 1 });

  //     }
  //   }
  // }
  // const handleZoomOut = (e:any) =>
  // {
  //   let height: any = zoomdetails.height;
  //   let width: any = zoomdetails.width;
  //   let GFG: any = document.querySelector(".imageZoom");
  //   if (width === "")
  //   {
  //     width = GFG.clientWidth;
  //     height = GFG.clientHeight;
  //   }
  //   width = width.toString();
  //   height = height.toString();
  //   width.replace("px", "");
  //   height.replace("px", "");
  //   width = parseInt(width) - 100 + "px";
  //   height = parseInt(height) - 100 + "px";
  //   setzoomdetails({ ...zoomdetails, height: height, width:width,steps: zoomdetails.steps -10});

  // };

  /**
   * Function used to handle zoom IN files in preview page
   */
  // const handleZoomIn = () =>
  // {

  // console.log()
  // let height: any = zoomdetails.height;
  // let width: any = zoomdetails.width;
  // let GFG: any = document.querySelector(".imageZoom");
  // if (width === "")
  // {
  //   width = GFG.clientWidth;
  //   height = GFG.clientHeight;
  // }
  // width = width.toString();
  // height = height.toString();
  // width.replace("px", "");
  // height.replace("px", "");
  // width = parseInt(width) + 100 + "px";
  // height = parseInt(height) + 100 + "px";
  // setzoomdetails({ ...zoomdetails, height: height, width:width,steps: zoomdetails.steps+10});

  //};


  //   const slideToZoom = (e: any) => {
  //     console.log(e,"777777777777777777777")
  //     let height: any = zoomdetails.imgHeight;
  //    let width: any = zoomdetails.imgWidth;
  //    width = width.toString();
  //    height = height.toString(); 
  //    width.replace("px", "");

  //    height.replace("px", "");
  //    width = parseInt(width) + e*10 + "px";
  //    height = parseInt(height) + e*10 + "px";
  //    setzoomdetails({ ...zoomdetails, height: height, width:e === 0?"":width,steps: e});
  //  }

  // const zoomImage = () => {
  //   let { isZoom, imgHeight, imgWidth, width, height } = zoomdetails;

  //   if (isZoom) {
  //     setzoomdetails({ ...zoomdetails, height: height / 2, width: width / 2, isZoom: false, steps: 0 });

  //   }
  //   else {
  //     setzoomdetails({ ...zoomdetails, width: imgWidth * 2, height: imgHeight * 2, isZoom: true, steps: 100 });
  //   }
  // }
  //console.log(zoomdetails, "zoomdetails")

  return (
    <>
    <div className="imagemodalcenter">
    <TransformWrapper 
        initialScale={1}
        onWheel={({state: {scale}}) => { 
          let scaleRes = scale === 1? 0: (scale +1)
          setzoomdetails ((zoomdetails) => ({ ...zoomdetails, steps: scaleRes }));
          }}
          onInit={(utils) => {
            (resetTransformRef as React.MutableRefObject<() => void>).current = utils.resetTransform;
          }}
        onZoom={(e: any) => {
          const scaleRes = e.state.scale ;
         setzoomdetails ((zoomdetails) => ({ ...zoomdetails, steps: scaleRes *12.5}));  
          }}
          // doubleClick={{ mode: "reset" }}
          >

        {({ zoomIn, zoomOut, resetTransform, ...rest}) => {

         const handleZoomIn = () => {
            zoomIn(1);
            setzoomdetails({ ...zoomdetails, steps:zoomdetails.steps+12.5});
          }
          const handleZoomOut = () => {
            zoomOut(1);
            setzoomdetails({ ...zoomdetails, steps: zoomdetails.steps -12.5});
          }

            const slideToZoom = _.debounce((e: any) => {
              const changing: any = Math.abs((e - zoomdetails.steps) / 100 * 8);
              if (e > zoomdetails.steps) {
                zoomIn(changing);
              } else if (e === 0) {
                resetTransform()
              } else {
                zoomOut(changing);
              }
              setzoomdetails({ ...zoomdetails, steps: e });
          
          }, 80)
            
          return (
            <React.Fragment>
              <TransformComponent>
                <div className={styles.imagezoom} >
                  <div className={styles.imagezoomfit} id="imgzoom">

                    <img className={"imageZoom"} src={url ? url : filePath} alt=''
                      style={{ width: zoomdetails.width, height: zoomdetails.height }}
                    />


                    <ChatLike className='likePreview' placement="topRight"
                      tooltipTitle={data?.likeduserdetails} message={data} />
                  </div>
                </div>
              </TransformComponent>
              <div className={styles.zoombuttons}>
                <Tooltip mouseEnterDelay={0.5} placement="top" title={'Zoom out'}>
                  {zoomdetails.steps > 0 ? <span className="icon_Preview-minus" onClick={() => handleZoomOut()}></span>
                    : <span className="icon_Preview-minus" onClick={() => handleZoomOut()}></span>
                  }
                </Tooltip>
                <Slider value={zoomdetails.steps} onChange={slideToZoom} style={{ width: "90px" }}></Slider>
                <Tooltip mouseEnterDelay={0.5} placement="top" title={'Zoom in'}>
                  {zoomdetails.steps < 100 ? <span className="icon_Preview-plus" onClick={handleZoomIn}></span> :
                    <span className="icon_Preview-plus" ></span>}
                </Tooltip>

              </div>
            </React.Fragment>
          )
        }}
      </TransformWrapper>
   
    </div>
       </>
  );
};



